webpackJsonp([377],{

/***/ 3604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(13);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(40);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(133);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MihyButton = function MihyButton(props) {
  var children = props.children,
      rest = (0, _objectWithoutProperties3.default)(props, ['children']);

  return _react2.default.createElement(
    _Button2.default,
    rest,
    children
  );
};

MihyButton.propTypes = {
  children: _propTypes2.default.any
};

exports.default = MihyButton;

/***/ })

});


// WEBPACK FOOTER //
// static/js/377.6feaebbf.chunk.js